import React from 'react'

import Notifications from 'components/Notifications/Notifications'

export default function NotificationsPage(): JSX.Element {
    return <Notifications />
}
